import { UrlConfig } from '@shared/config/url.config';

export class MesRemboursementsConfig {
  private static readonly listDossiers: string = `${UrlConfig.urlRemboursement}factures/search`;
  private static readonly listDossiersExport: string = `${UrlConfig.urlRemboursement}factures/export`;
  private static readonly destinatairePaiement: string = `${UrlConfig.urlRemboursement}destinataire-paiement`;

  public static get listeDossiers(): string {
    return MesRemboursementsConfig.listDossiers;
  }

  public static get listeDossiersExport(): string {
    return MesRemboursementsConfig.listDossiersExport;
  }

  public static get putDestinatairePaiement(): string {
    return MesRemboursementsConfig.destinatairePaiement;
  }
}
